<template>
    <div class="w-full h-full flex flex-col p-2 pt-6">
        <multi-sub-account-creator v-if="MultiCreateFeature.isEnabled()" :is-customer="isCustomer"/>
        <sub-account-list
            :sub-accounts="isCustomer ? customers : suppliers"
            :is-customer="isCustomer"
        />
    </div>
</template>

<script setup lang="ts">
import {onMounted} from 'vue'
import {hasSelectedOrg, orgSelectionComplete} from '@/tenants/org.service'
import SubAccountList from '@/subaccount/components/SubAccountList.vue'
import MultiSubAccountCreator from '@/components/MultiSubAccountCreator.vue'
import {MultiCreateFeature} from '@/subaccount/feature-toggles'
import {useSubAccounts} from '@/subaccount/subAccount.service'

const {customers, suppliers} = useSubAccounts()

defineProps({
    isCustomer: {type: Boolean, default: true}
})

onMounted(async () => {
    await orgSelectionComplete
    if (!hasSelectedOrg()) {
        console.error('Accessing the accounting page without selected org. Should not be possible, this is a bug!')
    }
})

</script>
